import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Box, Link } from '@mui/material'

const Logo = forwardRef(({ enabledLink = false, sx, ...other }: any, ref) => {
  const theme = useTheme()

  const PRIMARY_LIGHT = theme.palette.primary.light

  const PRIMARY_MAIN = theme.palette.primary.main

  const PRIMARY_DARK = theme.palette.primary.dark

  const logo = (
    <Box
      component="img"
      src={require(
        (theme.palette.mode === 'dark') ? '../assets/images/logo-dark.png' : '../assets/images/logo-light.png'
      )}
      sx={{ ...sx }}
    />
  )

  if (!enabledLink) {
    return logo
  }

  logo.props.sx.cursor = 'pointer'
  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  )
})
Logo.displayName = 'Logo'
Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool
}

export default Logo
